import {
  Directive,
  ElementRef,
  HostListener,
  Input,
  Renderer2,
} from '@angular/core';

@Directive({
  selector: '[firebirdWebHeight]',
  standalone: false,
})
export class HeightDirective {
  private domElement: HTMLElement;
  @Input('firebirdWebHeight') defaultSpaceConfig!: {
    componentSpacing: number;
    defaultTopOffset?: number;
  };
  @HostListener('window:resize') onResize() {
    this.setHeight();
  }

  constructor(private renderer: Renderer2, private elementRef: ElementRef) {
    // get ref HTML element
    this.domElement = this.elementRef.nativeElement as HTMLElement;
  }

  ngOnInit() {
    this.setHeight(this.defaultSpaceConfig.defaultTopOffset);
  }

  setHeight(defaultNum?: number) {
    const windowHeight = window?.innerHeight;
    const topOffset = this.calcTopOffset();
    const footerHeight = document.querySelector('.footer')?.clientHeight || 0;
    let height =
      windowHeight -
      topOffset -
      (footerHeight + this.defaultSpaceConfig.componentSpacing);
    if (defaultNum) {
      height = height - defaultNum;
    }
    if (height < 200) {
      height = 250;
    }
    this.renderer.setStyle(this.domElement, 'height', `${height}px`);
  }

  private calcTopOffset(): any {
    try {
      const rect = document
        .querySelector('.scroll-height')
        ?.getBoundingClientRect()?.top;
      return rect;
    } catch (e) {
      return 0;
    }
  }
}
